import React from "react";
import "../App.scss";
import { Toast, ToastContainer } from "react-bootstrap";

class InfoToast extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
  }

  render() {
    const { text, show, onClose, variant, delay } = this.props;

    // Eğer variant gelmezse varsayılan 'success' (yeşil) olsun
    // Eğer delay gelmezse varsayılan 3000ms olsun
    return (
        <ToastContainer position="top-center" className="p-3" style={{ zIndex: 9999 }}>
            <Toast
                bg={variant || "success"}
                onClose={onClose}
                delay={delay || 3000}
                show={show}
                autohide
            >
                {/* text-white ekledik çünkü bg-danger veya success koyu renk */}
                <Toast.Body className="text-white">
                    {text}
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
  }
}

export default InfoToast;